import React, { useState } from 'react';
import axios from 'axios';
import { useBusinessAuth } from '../../contexts/BusinessAuthContext';
import './AuthForms.css';

const SignupForm = ({ onSwitchToLogin }) => {
  const [daycareName, setDaycareName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login } = useBusinessAuth();

  const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:10000'}/api/auth`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${BASE_URL}/signup`, {
        daycareName,
        email,
        password,
      });

      if (response.status === 201) {
        const { token, daycare } = response.data;
        login(token, daycare);
      }
    } catch (err) {
      console.error('Signup error:', err);
      if (err.response?.status === 400) {
        setError(err.response.data.error || 'Invalid input');
      } else {
        setError('Signup failed. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h2>🐕 Sign up for BarkBacks</h2>
      <p className="auth-form-subtitle">Create an account to start generating amazing pet videos!</p>

      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label>Daycare Name: *</label>
          <input
            type="text"
            value={daycareName}
            onChange={(e) => setDaycareName(e.target.value)}
            placeholder="e.g., Paws & Play Daycare"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label>Email: *</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label>Password: *</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label>Confirm Password: *</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter your password"
            required
            disabled={isSubmitting}
          />
        </div>

        {error && (
          <div className="error-message">
            ❌ {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="auth-submit-button"
        >
          {isSubmitting ? '⏳ Creating account...' : '🚀 Sign Up'}
        </button>
      </form>

      <div className="auth-switch">
        <p>
          Already have an account?{' '}
          <button onClick={onSwitchToLogin} className="switch-link">
            Login here
          </button>
        </p>
      </div>

      <div className="free-trial-notice">
        <small>🎉 Start with 10 free videos per month!</small>
      </div>
    </div>
  );
};

export default SignupForm;
